import { NewsComplaintDto } from './news-complaint.dto';

export type NewsComplaintUpdateRequestDto = Partial<Pick<NewsComplaintDto, 'status' | 'operatorComment'>>;
